import * as React from 'react';
import Typography from '@mui/material/Typography';

function Copyright(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'はみると猫 / きたまお'}
        </Typography>
    );
}
export default Copyright;
